import AdvancedController from "./advanced-controller";
import gsap from "gsap";

const Config = {
  ANIMATION_DURATION: 0.75,
};

export default class LoginPopupController extends AdvancedController {
  static targets = [
    "popup"
  ];

  connect() {
    super.connect();
  }

  open() {
    gsap.to(this.popupTarget, {
      opacity: 1,
      display: "flex",
      duration: Config.ANIMATION_DURATION,
    });
  }

  close(e) {
    e.preventDefault();

    const onComplete = () => {
      this.popupTarget.style.display = "none";
    };
    gsap.to(this.popupTarget, {
      opacity: 0,
      duration: Config.ANIMATION_DURATION,
      onComplete,
    });
  }
}